export default "__VITE_ASSET__nhIwse3j__"